import { createElement, forwardRef, useMemo, useState } from 'react';
import dayjs from 'dayjs';
import classnames from 'classnames';
import { mergeProps } from '../../utils/with-default-props';
import { DayDom, Header, prefixCls } from './helper';
import { makeYearWeekList } from './tool';
import './index.scss';
const defaultProps = {
    showWeek: false,
    showLunar: true,
    showFest: true,
    moreFest: [],
    themeColor: '',
    selectedColor: '',
    titleBgColor: '',
    festColor: '',
    validDate: [],
    min: '',
    max: '',
    onSelectDate: () => { }
};
const ColorfulCalendar = forwardRef((p, ref) => {
    const today = dayjs();
    const props = mergeProps(defaultProps, p);
    const { showLunar, showFest, showWeek, min, max, titleBgColor, festColor, selectedColor, selectedDate, className, onSelectDate } = props;
    const [showYear, setShowYear] = useState(min && max ? dayjs(max).diff(dayjs(min), 'year') : 5);
    const weekList = useMemo(() => {
        return new Array(showYear).fill([]).reduce((_, acc, index) => {
            acc.push(...makeYearWeekList(today.clone().add(index, 'year'), min, max));
            return acc;
        }, []);
    }, [showYear]);
    return (createElement("div", { className: classnames(`${prefixCls}`, className) },
        showWeek ? createElement(Header, null) : null,
        createElement("div", { className: showWeek ? 'with-header' : '' }, weekList.map((m, index) => (createElement("div", { key: m[0], className: `${prefixCls}-month` },
            createElement("div", { className: `${prefixCls}-month-title`, style: { background: titleBgColor } }, m[0][6] ? m[0][6].format('YYYY年MM月') : ''),
            m.map(w => (createElement("div", { key: w, className: `${prefixCls}-month-tr` }, w.map((d, index) => (createElement(DayDom, { key: `${d}-${index}`, d: d, isWeekend: index === 0 || index === 6, showLunar: showLunar, showFest: showFest, festColor: festColor, selectedDate: selectedDate, selectedColor: selectedColor, onSelectDate: onSelectDate }))))))))))));
});
ColorfulCalendar.displayName = 'ColorfulCalendar';
export default ColorfulCalendar;
